import React, { useEffect, useState } from "react";
import Loading from "../../Common/Loading"

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const ResetEC: React.FC = () => {
    const [schoolCode, setSchoolCode] = useState("");
    const [familyCode, setFamilyCode] = useState("");
    const [login, setLogin] = useState("");
    const [setByTeacher, setSetByTeacher] = useState("");
    const [ecStatus, setEcStatus] = useState("");
    const [reportNo, setReportNo] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        document.body.style.backgroundColor = "white"
    })

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        const c = params.get("C") || params.get("SchoolCode") || "";
        const f = params.get("F") || params.get("FamilyCode") || "";
        const l = params.get("L") || params.get("Login") || "";

        setSchoolCode(c);
        setFamilyCode(f);
        setLogin(l);

        const fetchDetails = async () => {
            try {
                const res = await fetch(
                    `${API_BASE_URL}api/el-reset-ec/get-details/?SchoolCode=${encodeURIComponent(
                        c
                    )}&FamilyCode=${encodeURIComponent(f)}&Login=${encodeURIComponent(l)}`,
                    { method: "GET" }
                );
                const data = await res.json();

                if (data.found) {
                    setSetByTeacher(data.setByTeacher);
                    setEcStatus(data.ecStatus);
                    setReportNo(data.reportNo);
                } else {
                    setEcStatus(data.ecStatus || "There are no English Check records found");
                    // eslint-disable-next-line no-alert
                    window.alert("There are no English Check records found.");
                }
            } catch (err) {
                // eslint-disable-next-line no-alert
                window.alert("An error occurred while loading English Check details.");
            } finally {
                setLoading(false);
            }
        };

        fetchDetails();
    }, []);

    const handleReset = async () => {
        if (ecStatus === "EC Completed") {
            // eslint-disable-next-line no-alert
            window.alert("You cannot reset English Check that is already completed.");
            return;
        }

        try {
            const res = await fetch(`${API_BASE_URL}api/el-reset-ec/reset/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    schoolCode,
                    familyCode,
                    login,
                    reportNo,
                    setByTeacher,
                    ecStatus,
                }),
            });
            const data = await res.json();

            if (data.success) {
                setEcStatus(data.ecStatus);
                // eslint-disable-next-line no-alert
                window.alert("English Check was reset successfully.");
            } else if (data.alreadyCompleted) {
                // eslint-disable-next-line no-alert
                window.alert(data.message);
            }
            // if neither condition matched on backend, VB does nothing - no alert
        } catch (err) {
            // eslint-disable-next-line no-alert
            window.alert("An error occurred while resetting English Check.");
        }
    };

    const handleBack = () => {
        window.history.back()
    };

    return (
        <>
            <style>{`
        .reset-ec-wrapper {
          width: 40%;
          padding: 10px 40px 10px 40px;
        }

        .reset-ec-wrapper div {
          border-radius: 5px;
        //   background-color: #f2f2f2;
          padding: 2px;
        }

        .reset-ec-wrapper h1 {
          font-size: 1em;
          font-family: Arial, Helvetica, sans-serif;
          text-align: center;
        }

        #lblSchoolCode, #lblFname, #lblLogin, #lblSetByTeacher, #lblMDStatus {
          vertical-align: middle;
        }

        #txtSchoolCode, #txtFamily, #txtLogin, #txtSetByTeacher, #txtMDStatus {
          width: 60%;
          padding: 5px ;
          margin: 4px 0;
          display: inline-block;
          border: 1px solid #ccc;
          border-radius: 4px;
          font-size: 1em;
          font-family: Arial, Helvetica, sans-serif;
          text-decoration-color: azure;
        }

        .sch-code-holder, .fname-holder, .log-holder, .setbyteacher, .mdstatus {
          padding: 0px 0px 0px 0px;
          width: 100%;
        }

        #txtSchoolCode {
          margin-left: 90px;
          vertical-align: middle;
        }

        #txtLogin {
          margin-left: 134px;
          vertical-align: middle;
        }

        #txtFamily {
          margin-left: 127px;
          vertical-align: middle;
        }

        #txtSetByTeacher {
          margin-left: 28px;
          vertical-align: middle;
        }

        #txtMDStatus {
          margin-left: 103px;
          vertical-align: middle;
        }

        .btn-placeholder {
          width: auto;
          padding: 10px 0px 0px 60px;
        }

        #btnReset, #btnBack {
          width: 40%;
          background-color: #4CAF50;
          color: white;
          padding: 14px 30px;
          margin: 10px 0;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
      `}</style>

            <div className="reset-ec-wrapper" style={{ backgroundColor: "#f2f2f2" }}>
                {loading && (
                    <div
                    >
                        <Loading />
                    </div>
                )}
                <h1>Reset English Check</h1>

                <div className="sch-code-holder">
                    <label id="lblSchoolCode" htmlFor="txtSchoolCode">School Code</label>
                    <input id="txtSchoolCode" type="text" value={schoolCode} disabled readOnly />
                </div>

                <div className="fname-holder">
                    <label id="lblFname" htmlFor="txtFamily">Family</label>
                    <input id="txtFamily" type="text" value={familyCode} disabled readOnly />
                </div>

                <div className="log-holder">
                    <label id="lblLogin" htmlFor="txtLogin">Login</label>
                    <input id="txtLogin" type="text" value={login} disabled readOnly />
                </div>

                <div className="setbyteacher" style={{ marginBottom: "20px" }}>
                    <label id="lblSetByTeacher" htmlFor="txtSetByTeacher">Set By Teacher/Tutor?</label>
                    <input id="txtSetByTeacher" type="text" value={setByTeacher} disabled readOnly />
                </div>


                <div className="ecstatus">
                    <label id="lblECStatus" htmlFor="txtECStatus" style={{ marginRight: "5px" }}>EC Status</label>
                    <input id="txtECStatus" type="text" value={ecStatus} disabled readOnly />
                </div>

                <div className="btn-placeholder">
                    <button id="btnReset" type="button" onClick={handleReset} disabled={loading} style={{ marginRight: "8px" }}>
                        RESET
                    </button>
                    <button id="btnBack" type="button" onClick={handleBack}>
                        Close
                    </button>
                </div>
            </div>
        </>
    );
};

export default ResetEC;